<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini" @submit.native.prevent="onSubmit">
            <admin-parse-form-item ref="adminParseRef" :queryTemp="query" :pageType="4">
                <!-- <el-form-item label="链接制作状态：" class="query-form-item">
                    <el-select v-model="query.production_status" placeholder="链接制作状态" size="mini" style="width: 130px;">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="未分配" value="0"></el-option>
                        <el-option label="待制作" value="1"></el-option>
                        <el-option label="待分配" value="2"></el-option>
                        <el-option label="已分配" value="3"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="链接制作状态：" class="query-form-item">
                    <el-select v-model="query.link_production_status" placeholder="请选择" size="mini" style="width: 140px;">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in $common.linkProductionStatusArr"></el-option>
                    </el-select>
                </el-form-item>
            </admin-parse-form-item>

            <el-button type="primary" @click="onSubmit" size="mini" native-type="submit">查询</el-button>
            <el-button type="success" @click="onExport" size="mini">导出</el-button>
        </el-form>
        <el-table v-loading="loading" :data="list" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  @selection-change="handleSelectionChange" :height="tableHeight"
                  border @sort-change="handleSortChange" class="mini_div">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <table-asin-column></table-asin-column>

            <el-table-column label="销售国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                                :icon-class="scope.row.category_state.toUpperCase()"
                                style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="采购人员" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.developer_username }} <br/>
                        {{ scope.row.developer_full_name }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="运营人员" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.operation_username }} <br/>
                        {{ scope.row.operation_full_name }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="运营状态" width="150" align="center">
                <template slot-scope="scope">
                    <div v-show="scope.row.operation_id">
                        <el-popover placement="top-start" width="300" trigger="hover"
                                    v-show="scope.row.operation_status == 0"
                                    :content="' 运营选中时间 ' + scope.row.assign_operation_time">
                            <a style="color: blue" slot="reference">待运营</a>
                        </el-popover>
                        <el-popover placement="top-start" width="300" trigger="hover"
                                    v-show="scope.row.operation_status == 1"
                                    :content="' 开始运营时间 ' + scope.row.operation_running_time">
                            <a style="color: blue" slot="reference">运营中</a>
                        </el-popover>
                        <el-popover placement="top-start" width="300" trigger="hover"
                                    v-show="scope.row.operation_status == -1"
                                    :content="' 不再运营时间 ' + scope.row.operation_fail_time">
                            <a slot="reference">不再运营</a>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="运营Asin数量" width="140" align="center">
                <template slot-scope="scope">
                    <a @click="operatorAsinList(scope.row)" class="hover-effect canClick">{{
                        scope.row.operator_asin_count }}</a>
                </template>
            </el-table-column>

            <el-table-column label="是否符合利润" width="100" align="center">
                <template slot-scope="scope">
                    <div :style="{color: scope.row.is_conforming_profit == 1 ? 'green': 'red'}">
                        {{ scope.row.is_conforming_profit ? '是': '否'}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="链接制作" width="220" align="center">
                <template slot-scope="scope">
                    <div class="sku-data-item">状态: {{ getLinkProductionStatusText(scope.row.link_production_status) }}</div>
                    <div class="sku-data-item">时间: {{ scope.row.link_production_time || '-' }}</div>
                    <div class="sku-data-item" v-if="scope.row.link_production_path || scope.row.link_production_message">
                        <el-button type="warning" size="mini" v-if="scope.row.link_production_message"
                                   @click="$alert(scope.row.link_production_message, '生成信息')">信息</el-button>
                        <el-button type="success" size="mini" v-if="scope.row.link_production_path"
                                   @click="downFile(scope.row.link_production_path)">下载文件</el-button>
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="类目" min-width="360" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category }}</div>
                </template>
            </el-table-column>

            <el-table-column label="批量创建" width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.is_batch_import == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="选品原则" min-width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.selection_principle }}</div>
                </template>
            </el-table-column>

            <el-table-column label="标品类型" min-width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.standard_product_type == -1 ? '未录入' : scope.row.standard_product_type }}</div>
                </template>
            </el-table-column>

            <el-table-column label="专利" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini">{{scope.row.patent_value ? scope.row.patent_value : '-'}}</el-button><br/><br/>
                    <el-button type="success" @click="downFile(scope.row.patent_file)" size="mini" :disabled="!scope.row.patent_file">下载</el-button>
                </template>
            </el-table-column>
            <el-table-column label="标题" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>
            <el-table-column label="SKU数据" width="180" align="center">
                <template slot-scope="scope">
                    <div class="sku-data-item">SKU: {{ scope.row.sku || '-' }}</div>
                    <div class="sku-data-item">颜色: {{ scope.row.color || '-' }}</div>
                    <div class="sku-data-item">尺码: {{ scope.row.size || '-' }}</div>
                    <div class="sku-data-item">件装: {{ scope.row.box_quantity || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>
            <el-table-column label="销售价格" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.selling_price }}</div>
                </template>
            </el-table-column>


            <el-table-column label="1688产品链接" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.ali_href_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.ali_href_link)">跳转
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="1688产品价格" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_factory_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.ali_pic_url" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="1688产品标题" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_title }}</div>
                </template>
            </el-table-column>

            <el-table-column label="退货率" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ parseFloat((scope.row.refund_rate || 0) * 100).toFixed(2) }}%</div>
                </template>
            </el-table-column>

            <el-table-column label="长(cm)*宽(cm)*高(cm)-重(g)" width="190" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.long }}*{{ scope.row.wide }}*{{
                        scope.row.height
                        }}-{{ scope.row.weight }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="运费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运费单价/kg" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_unit_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运输模式" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deliver_mode }}</div>
                </template>
            </el-table-column>

            <el-table-column label="运费差" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_difference }}</div>
                </template>
            </el-table-column>

            <el-table-column label="平台佣金" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.platform_commission }}</div>
                </template>
            </el-table-column>
            <el-table-column label="亚马逊物流配送费" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.delivery_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="退货费用" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.refund_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Vat税费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.vat_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月仓储费" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月仓储费" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="美国旺季差额" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.us_peak_season_balance }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格(免税)" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月利润" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1-9月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月投资回报率" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{
                        scope.row['early_investment_return_rate'] ? accMul(scope.row['early_investment_return_rate'],
                        100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月投资回报率" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{
                        scope.row['late_investment_return_rate'] ? accMul(scope.row['late_investment_return_rate'], 100)
                        + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="利润率(含税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="利润率(免税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-'}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="类目树" min-width="180" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category_tree }}</div>
                </template>
            </el-table-column>
            <el-table-column label="父asin" width="110" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.parent_asin }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上架时间" width="140" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.listed_since }}</div>
                </template>
            </el-table-column>

            <el-table-column label="品牌" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.brand }}</div>
                </template>
            </el-table-column>
            <el-table-column label="评分" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating }}</div>
                </template>
            </el-table-column>

            <el-table-column label="评论数" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating_count }}</div>
                </template>
            </el-table-column>


            <el-table-column label="是否季节性" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.is_seasonality == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="季节" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.season }}</div>
                </template>
            </el-table-column>


            <el-table-column label="创建时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.create_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="分配采购时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.assign_developer_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="采购完成时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.assign_developer_finish_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运营选品时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.assign_operation_time }}</div>
                </template>
            </el-table-column>

            <el-table-column label="开始运营时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.operation_running_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="不再运营时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.operation_fail_time }}</div>
                </template>
            </el-table-column>


            <el-table-column label="规格包装" width="140" align="center">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="updateSpecificationPackage(scope.row)">查看</el-button>
                </template>
            </el-table-column>


            <el-table-column label="操作" width="270" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="cardFunc(scope.row)">卡片</el-button>
                    <el-button type="success" size="mini" @click="detailFunc(scope.row)">详情</el-button>
                    <el-button type="success" size="mini" @click="exportFunc(scope.row)">导出</el-button>
                    <el-button type="warning" size="mini" @click="synchronizationFunc(scope.row)">同步低价商城</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :current-page="query.page"
                :page-sizes="[10, 50, 100]"
                :total="query.total"
                background
                style="display: flex;justify-content: end;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <detail-preview ref="detailPreview"></detail-preview>

        <el-dialog
                title="修改运营ASIN"
                :visible.sync="asinUpdateVisible"
                width="30%"
                :before-close="closeCllback">
            <el-form>
                <el-form-item label="运营ASIN:" class="query-form-item">
                    <el-input style="width: 150px;" clearable v-model="copyData.operator_asin"
                              placeholder="请输入运营ASIN"
                              size="mini"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeCllback" size="mini">取 消</el-button>
                <el-button type="primary" @click="updateAsin" size="mini">确 定</el-button>
              </span>
        </el-dialog>
        <car-modal ref="card"></car-modal>
        <operatorListModal ref="operatorListModal" @refreshPage="closeCllback"/>
        <specification-package-modal ref="specificationPackageModal"
                                     @close-callback="closeCllback"></specification-package-modal>
        <export-dialog ref="exportDialogRef"/>
        <synchronization-dialog ref="synchronizationDialogRef"
                              @close-callback="closeCllback"></synchronization-dialog>
    </div>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import ChildInfoModal from './childInfoModal.vue'
    import DetailPreview from '@/views/warehouse/detailPreview.vue'
    import {downloadFileUrl} from '@/utils/method'
    import CarModal from '@/views/productStatistics/carModal.vue'
    import operatorListModal from '@/views/operationalSelection/components/operatorListModal.vue'
    import SpecificationPackageModal from '../costAnalysis/components/specificationPackageModal'
    import ExportDialog from '@/views/costAnalysisOne/exportDialog.vue'
    import AdminParseFormItem from '@/components/common/adminParseFormItem.vue'
    import synchronizationDialog from '@/views/costAnalysisOne/synchronizationDialog.vue'

    export default {
        components: {
            synchronizationDialog,
            AdminParseFormItem,
            ExportDialog, SpecificationPackageModal, operatorListModal, CarModal, DetailPreview, ChildInfoModal},
        data() {
            return {
                tableHeight: null,
                categoryList: [],
                managerAnalysisList: [],
                developerList: [],
                list: [],
                loading: false,
                copyData: {},
                asinUpdateVisible: false,
                query: {
                    page: 1,
                    limit: 10,
                    total: 0,
                },
                childInfo: {},
                ctrl: {
                    DownloadListDialogVisible: false,
                    uploadDialogVisible: false,
                    bidDialogVisible: false,
                    childInfoVisible: false,
                },
            }
        },
        mounted() {
            this.getCategoryList()
            this.getManagerAnalysisList()
            this.getList()
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        watch: {
            'query.category_state': {
                handler(val) {
                    this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                        if (item.name.indexOf(`${val}-`) !== -1) {
                            return item
                        }
                    })
                    this.getDeliverModeArr = ['', undefined, null].includes(val) ? this.$common.deliverModeArr : this.$common.deliverModeArr.filter(item => item.nation == val || item.value == '')
                    this.$set(this.query, 'category_id', '')
                    this.$set(this.query, 'deliver_mode', '')
                },
                deep: true,
                immediate: true
            },
            categoryList: {
                handler() {
                    const val = this.query.category_state
                    this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                        if (item.name.indexOf(`${val}-`) !== -1) {
                            return item
                        }
                    })
                },
                deep: true,
            }
        },
        computed: {
            showBack() {
                return this.$checkPermission('admin/cost_analysis/personal/return_from_purchase_finish_list')
            },
        },
        methods: {
            getLinkProductionStatusText(status) {
                const map = this.$common.linkProductionStatusMap
                return map[String(status)] || '-'
            },
            operatorAsinList(row) {
                this.$refs.operatorListModal.showModal(row.id)
            },
            modifyAsin(tempDate) {
                this.copyData = JSON.parse(JSON.stringify(tempDate))
                this.asinUpdateVisible = true
            },
            jumpUrlSplit(data) {
                const prefix = data.category_state == 'us' ? 'https://www.amazon.com/dp/' : data.category_state == 'uk' ? 'https://www.amazon.co.uk/dp/' : 'https://www.amazon.de/dp/'
                let url = prefix + data.operator_asin
                window.open(url, '_blank')
            },
            jumpUrl(url) {
                if (url) {
                    window.open(url, '_blank')
                } else {
                    this.$message.warning('没有链接')
                }
            },
            getCategoryList() {
                api.manager_index_get_category_message().then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.categoryList = res.data || []
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).catch(() => {
                    this.loading = false
                })
            },

            goBackFunc(data) {
                api.cost_analysis_personal_return_from_purchase_finish_list({id: data.id}).then((res) => {
                    if (res.success) {
                        this.$message.success('回退成功')
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            //重置
            onReset() {
                this.query = {
                    category_id: '',
                    operation_id: '',
                    developer_id: '',
                    category_state: '',
                    operation_status: '',
                    asin: '',
                    operator_asin: '',
                    screen_type: 3,
                    deliver_mode: '',
                    season: undefined,
                    min_freight_difference: undefined,
                    max_freight_difference: undefined,
                    min_weight: undefined,
                    max_weight: undefined,
                    min_early_profit: undefined,
                    max_early_profit: undefined,
                    page: 1,
                    limit: 10,
                    total: 0,
                }
                this.getList()
            },
            updateSpecificationPackage(data) {
                this.$refs.specificationPackageModal.openModal(data)
            },
            cardFunc(data) {
                api.manager_index_get_single_cost_analysis_detail_data({id: data.id}).then(res => {
                    if (res.success) {
                        this.$refs.card.showModal(res.data)
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            },
            detailFunc(data) {
                this.$refs.detailPreview.visible = true
                this.$refs.detailPreview.title = '详情展示'
                this.$refs.detailPreview.formData = data
                this.$refs.detailPreview.funcType = 1
            },
            synchronizationFunc(data){
                this.$refs.synchronizationDialogRef.openModal(data)
            },
            exportFunc(data) {
                api.operation_index_export({id: data.id}).then((res) => {
                    if (res.success) {
                        this.downFile(res.data)
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            closeCllback(isShow) {
                this.showAddRecord = false
                this.showAddParseModal = false
                this.asinUpdateVisible = false
                this.ctrl.childInfoVisible = false
                this.updateData = {}
                isShow == true && this.getList()
            },
            updateAsin() {
                api.cost_analysis_personal_update_field({
                    id: this.copyData.id,
                    operator_asin: this.copyData.operator_asin,
                }).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        })
                        this.closeCllback(true)
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '网络出现问题，请刷新页面！'
                    })
                })
            },
            /**
             * 数字相乘
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accMul(arg1, arg2) {
                let m = 0
                m = this.accAdd(m, this.getDecimalLength(arg1))
                m = this.accAdd(m, this.getDecimalLength(arg2))
                return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
            },
            getNum(arg = '') {
                return Number((arg || "").toString().replace('.', ''))
            },
            /**
             * 数字相加
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accAdd(arg1, arg2) {
                return this.changeNum(arg1, arg2)
            },
            changeNum(arg1 = '', arg2 = '', isAdd = true) {
                const changeInteger = (arg, r, maxR) => {
                    if (r != maxR) {
                        let addZero = ''
                        for (let i = 0; i < maxR - r; i++) {
                            addZero += '0'
                        }
                        arg = Number(arg.toString().replace('.', '') + addZero)
                    } else {
                        arg = this.getNum(arg)
                    }
                    return arg
                }

                let r1, r2, maxR, m
                r1 = this.getDecimalLength(arg1)
                r2 = this.getDecimalLength(arg2)
                maxR = Math.max(r1, r2)
                arg1 = changeInteger(arg1, r1, maxR)
                arg2 = changeInteger(arg2, r2, maxR)
                m = Math.pow(10, maxR)
                if (isAdd) {
                    return (arg1 + arg2) / m
                } else {
                    return (arg1 - arg2) / m
                }
            },
            getDecimalLength(arg = '') {
                try {
                    return arg.toString().split('.')[1].length
                } catch (e) {
                    return 0
                }
            },

            spanMethod({row, column, rowIndex, columnIndex}) {

                const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
                if (rowIndex % 3 == 0) {
                    if (columns.includes(columnIndex)) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                    return {
                        rowspan: 3,
                        colspan: 1
                    }
                } else {
                    if (columns.includes(columnIndex)) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            },
            //查询
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            onExport() {
                const tempQuery = this.$refs.adminParseRef.handleQueryData()
                this.$refs.exportDialogRef.openModal(tempQuery)
            },
            clickRowHandle(row, column) {
                let update = false
                if (['标题', '类目树', '子类目', '1688产品标题', '颜色', '备注'].includes(column.label)) {
                    this.childInfo.title = column.label
                    let info = row.title
                    if (column.label == '类目树') {
                        info = row.category_tree
                    } else if (column.label == '子类目') {
                        info = row.categories_str
                    } else if (column.label == '颜色') {
                        info = row.color
                    } else if (column.label == '1688产品标题') {
                        info = row.ali_title
                    } else if (column.label == '备注') {
                        info = row.remark
                        update = true
                    }
                    this.childInfo.id = row.id
                    this.childInfo.info = info
                    this.childInfo.update = update
                    this.ctrl.childInfoVisible = true
                }
                if (['折叠', '收起'].includes(column.label)) {
                    this.isFold = !this.isFold
                }
            },
            clickHeaderHandle(row, column) {
                if (['折叠', '收起'].includes(row.label)) {
                    this.isFold = !this.isFold
                }
            },
            handleSortChange(val) {
                if (val.order == 'ascending') {
                    this.query.desc = 'desc'
                    this.query.order = val.prop
                } else if (val.order == 'descending') {
                    this.query.desc = 'asc'
                    this.query.order = val.prop
                }
                this.getList()
            },
            handleSelectionChange(val) {
                let arr = []
                val.map(v => {
                    arr.push(v.id)
                })
                arr = Array.from(new Set(arr))
                this.multipleSelection = arr
            },
            chooseItem(data) {
                this.$emit('choose1688Info', data)
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                const tempQuery = this.$refs.adminParseRef.handleQueryData()
                api.manager_cost_analysis_manager_purchase_finish_list({...tempQuery}).then(res => {
                    if (res.code === 0) {
                        const responseList = res.data.list || []
                        this.list = responseList
                        this.query.total = res.data.total || 0
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                }).finally(() => {
                    this.loading = false
                })
            },
            getManagerAnalysisList() {
                api.manager_index_get_operator_list().then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        const responseList = res.data || []
                        this.managerAnalysisList = responseList
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).catch(() => {
                    this.loading = false
                })
                api.manager_index_get_developer_list().then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        const responseList = res.data || []
                        this.developerList = responseList
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.loading = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    .canClick {
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }

    .sku-data-item {
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .fixedHeight {
        height: 30px;
        line-height: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }

    .hover-effect:hover {
        text-decoration: underline; /* 鼠标移动时添加下划线 */
        color: red; /* 鼠标移动时字体颜色变为红色 */
        font-weight: bold; /* 鼠标移动时加粗 */
        cursor: pointer;
    }
</style>
